'use strict';
const angular = require('angular');

/*@ngInject*/
export function SettingsService($resource) {
  return $resource('/api/settings/:id', {
    name: '@_id'
  },{
    getSystemInfo: {
      method: 'GET',
      url: "/api/settings/system-info"
    },
    getCacheStats: {
      method: 'GET',
      url: "/api/settings/cache/stats"
    },
    flushCache: {
      method: 'GET',
      url: "/api/settings/cache/flush"
    },
    getByName: {
      method: 'GET',
        url: "/api/settings/name/:name"
    },
    update: {
      method: 'PUT'
    }
  });
}


export default angular.module('conduu.SettingsService', [])
  .factory('SettingsService', SettingsService)
  .name;



// WEBPACK FOOTER //
// ./client/components/settings/settings.service.js